var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkerPen = function SvgMarkerPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M1.75 12.75h1.069l7.331-7.331L9.081 4.35 1.75 11.681zm-1.5 1.5v-3.187l9.9-9.882q.225-.206.497-.318.272-.114.572-.113.3 0 .581.113.282.112.487.337l1.032 1.05q.226.207.328.487a1.63 1.63 0 0 1 0 1.135 1.4 1.4 0 0 1-.328.497L3.438 14.25zm9.356-9.356-.525-.544 1.069 1.069z"
  })));
};
export default SvgMarkerPen;